import thumb_up from './SelectAccount/images/thumb_up.svg';
import hey from './SelectAccount/images/hey.svg';

export const stepEnum = {
  OTP: 'otp',
  SELECT_ACCOUNT: 'selectaccount',
  PACKAGE_SELECT: 'packageselect',
  PACKAGE_REVIEW: 'packagereview',
  WARNING_ALERT: 'warningalert',
  CONTACT_FORM: 'contactform',
  COMPLETED: 'completed',
  CALL_BACK: 'callback',
  ERROR_WITH_LOGIN_REDIRECT: 'errorloginredirect',
  FINISHMAGICLINK: 'finishMagicLink',
  FROM_MAGICKINK: 'fromMagicLink',
  DATALOAD: 'DATALOAD',
  SHOWPACKAGES: 'SHOWPACKAGES',
  SHOWSUBSCRIBERS: 'SHOWSUBSCRIBERS',
  ERROR: 'ERROR',
  FINISHEDSUCCESS: 'FINISHEDSUCCESS',
  FINISHEDFAIL: 'FINISHEDFAIL',
  CHANGEALL: 'CHANGEALL',
  TRANSITION_ANIMATION: 'TRANSITION_ANIMATION',
  BLOCKING_DUAL_NUMBER: 'BLOCKING_DUAL_NUMBER',
};

export const packageSelectionStatus = {
  VALIDATION: 'validation',
  SELECTING: 'selecting',
  MULTI_SELECT: 'multi_select',
  CONFIRMATION: 'CONFIRMATION',
};

export const MagicLinkEnum = {
  LINK: 'LINK',
  VALIDATION: 'VALIDATION',
  INVALID: 'INVALID',
  GENERAL: 'GENERAL',
  MAXCAP: 'MAXCAP',
  FAILED: 'FAILED',
  INVALIDFATHER: 'INVALIDFATHER',
  MLERROR: 'MLERROR',
}

const brandNameHe = () => window.Config?.brand_Name_HE ?? 'סלקום';

export const magicLinkReponse = (res) => {
  switch (res.codeError) {
    case MagicLinkEnum.LINK:
      return {
        icon: thumb_up,
        isSuccess: res.isSuccess,
        codeError: res.codeError,
        resultMessage: `איזה כיף שבחרת לצרף לתוכנית בן משפחה!`,
        message: res.extra.phone != res.extra.primaryNum ? "שמנו לב שהמספר שביקשת לצרף הינו בבעלות אחרת. ברגעים אלה שלחנו לבעל החשבון SMS עם לינק להצטרפות, למספר" : "מיד נשלח SMS עם לינק הצטרפות למספר",
        phoneNum: res.extra.phone != res.extra.primaryNum ? `${res.extra.primaryNum.slice(6)}******` : res.extra.phone,
      };
    case MagicLinkEnum.VALIDATION:
      return {
        icon: hey,
        isSuccess: res.isSuccess,
        codeError: res.codeError,
        resultMessage: `שמנו לב שקו מספר ${res.extra.phone} לא קיים ב${brandNameHe()} `,
        message: "האם להתחיל ניוד?",
        extra: `כן אני רוצה לנייד ל${brandNameHe()}`,
        footerText: "חזרה לאיזור האישי",
        phoneNum: res.extra.phone,
      };
    case MagicLinkEnum.INVALID:
      return {
        icon: hey,
        isSuccess: res.isSuccess,
        codeError: res.codeError,
        resultMessage: `שמנו לב שקו מספר ${res.extra.phone} לא תקין `,
        message: "לפרטים ומידע נוסף התקשרו ל-2759*",
        phoneNum: res.extra.phone,
        extra: "הבנתי, תודה",
      };
    case MagicLinkEnum.GENERAL:
      return {
        icon: hey,
        isSuccess: res.isSuccess,
        codeError: res.codeError,
        resultMessage: `מצטערים, משהו השתבש בתהליך ולא ניתן לבצע את הפעולה שביקשת`,
        message: "נציגנו ישמחו לסייע לך",
        extra: "חזרה לאיזור האישי",
        phoneNum: res.extra.phone,
      };
    case MagicLinkEnum.MAXCAP:
      return {
        icon: hey,
        isSuccess: res.isSuccess,
        codeError: res.codeError,
        resultMessage: `מימשת ${res.extra.cap} הטבות של תוכנית בני משפחות"`,
        message: "",
        extra: "הבנתי, תודה",
        phoneNum: res.extra.phone,
      };
    case MagicLinkEnum.FAILED:
      return {
        icon: hey,
        isSuccess: res.isSuccess,
        codeError: res.codeError,
        resultMessage: `שליחת לינק למספר ${res.extra.phone} נכשלה `,
        message: "לפרטים ומידע נוסף התקשרו ל-*2759",
        extra: "הבנתי, תודה",
        phoneNum: res.extra.phone,
      };
    case MagicLinkEnum.INVALIDFATHER:
      return {
        icon: hey,
        isSuccess: false,
        codeError: '55',
        resultMessage: `ראינו שניסית לעדכן תוכנית לקו מספר ${res.extra.phone} שלא נמצא בבעלותך`,
        message: "לפרטים ומידע נוסף התקשרו ל-*2759",
        extra: "הבנתי, תודה",
        phoneNum: res.extra.phone,
      };
    case MagicLinkEnum.MLERROR:
      return {
        icon: hey,
        isSuccess: res.isSuccess,
        codeError: res.codeError,
        resultMessage: "לא ניתן לבצע העברת תוכנית למשתמש זה",
        message: "לפרטים ומידע נוסף התקשרו ל-*2759",
        extra: "הבנתי, תודה",
        phoneNum: res.extra.phone,
      };
    default:
      return {
        icon: hey,
        isSuccess: res.isSuccess,
        codeError: res.codeError,
        resultMessage: "משהו השתבש, אנא נסו שוב",
        extra: "הבנתי, תודה",
      };;
  }
};
